import React, { useState } from 'react';
import { SHAREHOLDER_TYPES, ENTITY_TYPES } from '../constants';

const ShareholderForm = ({ onSubmit, onCancel, initialData = {} }) => {
  const [data, setData] = useState({
    entity_type: initialData.entity_type || ENTITY_TYPES[0],
    name: initialData.name || '',
    first_name: initialData.first_name || '',
    middle_name: initialData.middle_name || '',
    last_name: initialData.last_name || '',
    email: initialData.email || '',
    type: initialData.type || SHAREHOLDER_TYPES[0],
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const submitData = { ...data };
    
    if (data.entity_type === 'Individual') {
      // For individuals, construct the main 'name' field from the parts.
      submitData.name = [data.first_name, data.middle_name, data.last_name]
        .filter(Boolean) // Remove any empty parts
        .join(' ')
        .trim();

      // Clean up middle name if it's empty
      if (!submitData.middle_name || submitData.middle_name.trim() === '') {
        delete submitData.middle_name;
      }
    } else {
      // For non-individuals, remove individual name fields to keep data clean
      delete submitData.first_name;
      delete submitData.middle_name;
      delete submitData.last_name;
    }
    
    onSubmit(submitData);
  };

  const renderNameFields = () => {
    if (data.entity_type === 'Individual') {
      return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">First Name *</label>
            <input
              type="text"
              value={data.first_name}
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Middle Name</label>
            <input
              type="text"
              value={data.middle_name}
              onChange={(e) => setData({ ...data, middle_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name *</label>
            <input
              type="text"
              value={data.last_name}
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{data.entity_type} Name *</label>
          <input
            type="text"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="text-lg font-bold mb-4">{initialData.id ? 'Edit Shareholder' : 'Add New Shareholder'}</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Entity Type *</label>
          <select
            value={data.entity_type}
            onChange={(e) => setData({ ...data, entity_type: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            {ENTITY_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        {renderNameFields()}
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="email"
            value={data.email}
            onChange={(e) => setData({ ...data, email: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Shareholder Type *</label>
          <select
            value={data.type}
            onChange={(e) => setData({ ...data, type: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            {SHAREHOLDER_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="flex justify-end space-x-2 mt-6">
        <button 
          type="button" 
          onClick={onCancel} 
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
        >
          Cancel
        </button>
        <button 
          type="submit" 
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          {initialData.id ? 'Update Shareholder' : 'Add Shareholder'}
        </button>
      </div>
    </form>
  );
};

export default ShareholderForm;
